import React from 'react'
import '../App.css';
import { Link } from 'react-router-dom'


function Dropdown(props) {
  
    return (
        <div className="Dropdown">
            <li className = "Links"> 
            <Link className = "DropdownLinks" onClick = {() => props.ref3.current.scrollIntoView({behavior: 'smooth'})}> What is Foodies? </Link>
            <Link className = "DropdownLinks" onClick = {() => props.ref1.current.scrollIntoView({behavior: 'smooth'})}> Meal Buddy </Link> 
            <Link className = "DropdownLinks" onClick = {() => props.ref2.current.scrollIntoView({behavior: 'smooth'})}> Food Jackpot </Link>
            </li>
        </div>
    )
}

export default Dropdown
